import { Avatar } from 'src/design/atoms/Avatar';
import { Box } from 'src/design/atoms/Box';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { IconArrowBackUp } from '@tabler/icons-react';
import React from 'react';
import { EmailAttachmentDto, EmailDto } from 'src/api/FiretrolApiClient';
import { useDownloadEmailAttachment } from 'src/api/queries/emails/useDownloadEmailAttachment';
import { BasicButton } from 'src/design/atoms/BasicButton';

export interface IEmailListProps {
  emails: EmailDto[];
}

export const EmailList: React.FC<IEmailListProps> = ({ emails }) => {
  const downloadEmailAttachment = useDownloadEmailAttachment();

  const onReplyClick = (email: EmailDto) => {
    const ccEmails = `cc=${email.toRecipients?.map(
      (r, idx) =>
        `${r.recipient.address}${
          idx === email.toRecipients?.length - 1 ? '' : ';'
        }`,
    )}`;
    const url = `mailto:${email.sender?.address}?subject=Re: ${email.subject}&${ccEmails}&body=%0D%0A%0D%0A---------%0D%0A%0D%0A${email.bodyPreview}`;
    window.open(url, '_blank');
  };

  const downloadAttachment = async (attachment: EmailAttachmentDto) => {
    const result = await downloadEmailAttachment
      .mutateAsync(Number(attachment.technicalKey))
      .catch(() => null);
    if (result) window.open(result.url, '_blank');
  };

  const renderAttachments = (attachments: EmailAttachmentDto[]) => {
    return attachments.map((att) => {
      return (
        <Box key={att.technicalKey}>
          <BasicButton
            variant="subtle"
            size="compact-xs"
            onClick={() => downloadAttachment(att)}
          >
            {att.name}
          </BasicButton>
        </Box>
      );
    });
  };

  const renderItems = () => {
    return emails.map((email) => {
      return (
        <Paper key={email.technicalKey}>
          <Group justify="space-between" align="flex-start">
            <Group align="flex-start" gap="md">
              <Avatar size="md" color="blue">
                {email.sender?.name.slice(0, 1)}
              </Avatar>

              <Stack>
                <Text c="bright" size="md">
                  {email.subject}
                </Text>
                <Group>
                  <Text component="span" fw={500} c="dark">
                    {email.sender?.name}
                  </Text>
                  <Text size="sm" c="dimmed">
                    {' - '}
                    {email.bodyPreview}
                  </Text>
                </Group>

                {email.attachments.length > 0 &&
                  renderAttachments(email.attachments)}
              </Stack>
            </Group>

            <BasicButton
              size="compact-xs"
              variant="subtle"
              leftSection={<IconArrowBackUp size={16} />}
              onClick={() => onReplyClick(email)}
            >
              Reply
            </BasicButton>
          </Group>
        </Paper>
      );
    });
  };

  return (
    <Stack gap="xs" style={{ maxWidth: 600 }}>
      {renderItems()}
    </Stack>
  );
};
